import { Box, Dialog as MuiDialog, styled, DialogContent, DialogTitle, FormControl, Grid, IconButton, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import CalendarModel from "../ApheresisRequests/CalendarModel";
import { CalendarIcon } from "@mui/x-date-pickers";
import FormLabel from "../../../components/styled/FormLabel";
import FormField from "../../../components/styled/FormField";
import moment from "moment";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal"
import { bookSlot, deleteSlot, selectApheresisLoading, updateSlot } from "../../../slices/apheresis";
import { hasAuthority } from "../../../../utils/authorities";
import CrossIcon from "../../../assets/images/icons/cross.icon";
import { clinicalStatus, financialStatus, paymentTypeOptions, SUPPORTED_FORMATS } from "../../../../pages/appointment-details/common-pre-screen/common";
import { dateFormater } from "../../../utils/common/utils";
import FileUploadComponent from './FileUploadComponent'
import DownloadImageApi from "../../../../services/downloadImageService"

const Dialog = styled(MuiDialog)({
    '& .MuiPaper-root': {
        overflowY: 'inherit',
        borderRadius: 10,
        border: 0
    }
});
const ApheresisUpdateForm = ({ slotData, fetchEvents, handleCloseModal, open, onClose }) => {

    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || []
    const [formData, setFormData] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(null)
    const [errors, setErrors] = useState({});
    const [actionType, setActionType] = useState(null);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const isLoading = useSelector(selectApheresisLoading);
    const dispatch = useDispatch();
    useEffect(() => {
        setFormData({
            manufacturing_id: slotData?.manufacturing_id || "",
            slot_id: slotData?.id || "",
            slot_alignment_id: slotData?.slot_alignment_id || "",
            date: dateFormater(slotData?.date) || "",
            comment: slotData?.slot_alignment_reason || "",
            media: slotData?.media || "",
        })
    }, [slotData])

    const validate = (type) => {
        const newErrors = {};

        if ((type === "delete" || type === "update" || type === "confirm") && !formData.comment.trim()) {
            newErrors.comment = "Comment is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: null
            }));
        }
    };

    const handleDownload = async (id) => {
        try {
            const imgRes = await DownloadImageApi.getDownloadedImageul(id);
            const response = await fetch(imgRes?.data || "");

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response?.url;
        } catch (error) {
            // console.error("Download failed:", error);
            console.log("Download failed. Please try again later.");
        }
    };

    const handleDeleteSlot = async () => {
        await dispatch(deleteSlot(deleteOpen));
        setDeleteOpen(null)
        fetchEvents();
        handleCloseModal();
    }
    const handleSubmit = async (type) => {
        if (!validate(type)) return;
        try {
            const payload = {
                id: slotData?.id,
                data: {
                    comment: formData.comment,
                    subject_id: slotData?.subject_id,
                    ...(formData?.media_id?.length ? { media_id: formData.media_id } : {})
                }
            };

            if (type === "delete") {
                setDeleteOpen(payload)
            } else if (type === "confirm") {
                await dispatch(bookSlot(payload));
                fetchEvents();
                handleCloseModal();
            } else if (type === "update") {
                await dispatch(updateSlot({
                    id: formData.slot_id,
                    data: {
                        slot_alignment_id: formData.slot_alignment_id,
                        comment: formData.comment,
                    }
                }));
                fetchEvents();
                handleCloseModal();
            }
        } catch (error) {
            console.error("Submission error:", error);
        }
    };

    const handleAction = (type) => {
        setActionType(type);
        handleSubmit(type);
    };


    const formFields = [
        {
            label: 'Manufacturing Facility Name',
            type: 'text',
            name: 'location',
            required: true,
            value: slotData?.allLocation?.items?.find(op => op.id == formData?.manufacturing_id)?.name,
            placeholder: 'Select Location',
            disabled: true,
            error: errors.manufacturing_id,
            helperText: errors.manufacturing_id,
        },
        {
            label: slotData?.type === "Request" ? 'Requested Date' : 'Apheresis Date',
            type: 'text',
            name: 'date',
            required: true,
            disabled: !hasAuthority(["update-apheresis-slot"], bmr_permissions),
            placeholder: 'Select date',
            value: formData?.date,
            onClick: () => setCalendarOpen(true),
            readOnly: true,
            error: errors.date,
            helperText: errors.date,
        },
        {
            label: "Select Attachment",
            type: "file",
            name: "media_id",
            multiple: true,
            disabled: !(slotData?.type === "Request" && hasAuthority(["confirm-apheresis-slot"], bmr_permissions)),
            removeButton: !(slotData?.type === "Request" && hasAuthority(["confirm-apheresis-slot"], bmr_permissions)),
            acceptFormat: SUPPORTED_FORMATS,
            error: errors.media_id,
            helperText: errors.media_id,
            downloadFile: handleDownload,
            placeholder: "Select a File",
            required: false,
            col: 1,
        },
        {
            label: 'Comment',
            type: 'textarea',
            name: 'comment',
            disabled: !(
                hasAuthority(["delete-apheresis-slot"], bmr_permissions) ||
                hasAuthority(["confirm-apheresis-slot"], bmr_permissions) ||
                hasAuthority(["update-apheresis-slot"], bmr_permissions)
            ),
            required: true,
            placeholder: 'Enter comment',
            value: formData?.comment,
            onChange: handleChange,
            error: errors.comment,
            helperText: errors.comment,
            multiline: true,
            rows: 4,
        },
    ];

    const handleCloseCalendarModal = () => {
        setCalendarOpen(false);
    };

    const handleSelectedSlot = (id, date) => {
        setFormData({ ...formData, slot_id: id, slot_name: "Slot", date: dateFormater(date) })
    }
    return (

        <Dialog
            fullWidth={false}
            open={open}
            onClose={onClose}
            maxWidth={"xl"}
        >
            <DialogTitle className="m-0 p-3 border-b border-[#DDDDDD] ">
                <div>
                    <div className="flex items-center gap-2 text-base font-semibold">
                        <span> {slotData?.patient_name}</span>
                        <span>|</span>
                        <span className="capitalize">{slotData?.phase_name} ({slotData?.product_name})</span>
                        <span className="text-xs font-medium bg-blue-100 text-blue-600 px-2 py-1 rounded">{slotData?.phase_type}</span>
                        <div className="flex items-center space-x-1">
                            <span
                                className={`w-3 h-3 rounded-full ${slotData?.type === "Request"
                                    ? "bg-[#FB9D2C]"
                                    : slotData?.type === "Booked"
                                        ? "bg-[#ff2023]"
                                        : "bg-gray-300"
                                    }`}
                            ></span>
                            <span
                                className={`text-sm font-medium ${slotData?.type === "Request"
                                    ? "text-[#FB9D2C]"
                                    : slotData?.type === "Booked"
                                        ? "text-[#ff2023]"
                                        : "text-gray-500"
                                    }`}
                            >
                                {slotData?.type == 'Request' ? 'Booked': slotData?.type == 'Booked' ? 'Confirmed' :slotData?.type}
                            </span>
                        </div>
                    </div>
                    <p className="text-gray-500 mt-1 uppercase">{slotData?.hospital_name} </p>
                </div>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                className="absolute top-[-30px] right-[-34px] text-neutral-100 rounded-circle"
            >
                <CrossIcon color="#ffffff" size={16} />
            </IconButton>
            <DialogContent dividers className="border-bottom-0 border-0">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Box
                        sx={{
                            padding: 0,
                            minWidth: 400,
                            borderRadius: '0.75rem',
                            bgcolor: 'white',
                            color: 'text.primary',
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                        }}
                    >

                        <Box>
                            <div className="p-3" style={{
                                backgroundColor: clinicalStatus[slotData?.clinical_status]?.bgColor,
                                borderTopRightRadius: '0.75rem',
                                borderTopLeftRadius: '0.75rem',
                            }}>
                                <Typography variant="subtitle2" sx={{ color: clinicalStatus[slotData?.clinical_status]?.text, fontWeight: 'bold' }}>
                                    Clinical Feasibility
                                </Typography>
                            </div>
                            <div className="p-3 flex flex-col gap-4">
                                <div className="flex gap-4">
                                    <Typography variant="body1" className="flex gap-2">
                                        <span className="text-[#808080]">Feasibility  </span>
                                        <span>
                                            {clinicalStatus[slotData?.clinical_status]?.lable}
                                        </span>
                                    </Typography>
                                    <Typography variant="body1" className="flex gap-2">
                                        <span className="text-[#808080]">Date  </span>{" "}
                                        <span>
                                            {slotData?.updated_at && moment(slotData?.updated_at).format("DD/MM/YYYY")}
                                        </span>
                                    </Typography>
                                </div>
                                <Typography variant="body1" className="flex gap-2">
                                    <span className="text-[#808080]">Approved By  </span>{" "}
                                    <span>
                                        {slotData?.clinical_by_name}
                                    </span>
                                </Typography>
                                <Typography variant="body1" className="flex flex-col">
                                    <span className="text-[#808080]">Comment </span>
                                    <span>{slotData?.clinical_feasibility_comment || "--"}</span>
                                </Typography>
                                 {slotData && slotData?.clinical_media?.length > 0 ?
                                  <Typography variant="body1" className="flex flex-col">
                                    <span className="text-[#808080]">Comment </span>
                                <FileUploadComponent 
                                field={{disabled:true,removeButton:true,downloadFile:handleDownload}}
                                formData={{ media:slotData?.clinical_media }} 
                                /> </Typography>:''}
                            </div>
                        </Box>
                    </Box>

                    {/* Financial Feasibility */}
                    <Box
                        sx={{
                            padding: 0,
                            minWidth: 400,
                            borderRadius: '0.75rem',
                            bgcolor: 'white',
                            color: 'text.primary',
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <Box>
                            <div className="p-3" style={{
                                backgroundColor: financialStatus[slotData?.financial_status]?.bgColor,
                                borderTopRightRadius: '0.75rem',
                                borderTopLeftRadius: '0.75rem',
                            }}>
                                <Typography variant="subtitle2" sx={{ color: financialStatus[slotData?.financial_status]?.text, fontWeight: 'bold' }}>
                                    Financial Feasibility
                                </Typography>
                            </div>
                            <div className="p-3 flex flex-col gap-4">
                                <div className="flex gap-4">
                                    <Typography variant="body1" className="flex gap-2">
                                        <span className="text-[#808080]">Feasibility  </span>
                                        <span>
                                            {financialStatus[slotData?.financial_status]?.lable}
                                        </span>
                                    </Typography>
                                    <Typography variant="body1" className="flex gap-2">
                                        <span className="text-[#808080]">Date  </span>{" "}
                                        <span>
                                            {slotData?.updated_at && moment(slotData?.updated_at).format("DD/MM/YYYY")}
                                        </span>
                                    </Typography>
                                </div>
                                {slotData?.payment_type && (
                                    <Typography variant="body1" className="flex gap-2">
                                        <span className="text-[#808080]">Payment Type  </span>{" "}
                                        <span>
                                            {paymentTypeOptions?.find(op => op.value === slotData?.payment_type)?.label}
                                        </span>
                                    </Typography>
                                )}
                                <Typography variant="body1" className="flex gap-2">
                                    <span className="text-[#808080]">Approved By  </span>{" "}
                                    <span>
                                        {slotData?.financial_by_name}
                                    </span>
                                </Typography>
                                <Typography variant="body1" className="flex flex-col">
                                    <span className="text-[#808080]">Comment </span>
                                    <span>{slotData?.financial_feasibility_comment || "--"}</span>
                                </Typography>
                                {slotData && slotData?.financial_media?.length > 0 ?
                                <FileUploadComponent 
                                field={{disabled:true,removeButton:true,downloadFile:handleDownload}}
                                formData={{ media:slotData?.financial_media }} 
                                />:''}
                            </div>
                        </Box>
                    </Box>
                </div>
                <hr className="mt-3 mb-3" />
                <div>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}>
                        <Grid container spacing={2} className="mb-3">
                            {formFields.map((field, index) => (
                                <Grid key={index} item xs={field.type == "textarea" || field.type == "file" ? 12 : 6}>
                                    {field.name === 'date' ? (
                                        <FormControl variant="standard" fullWidth>
                                            <Box className="relative">
                                                <FormLabel shrink required={field.required}>
                                                    {field.label}
                                                </FormLabel>
                                                <FormField
                                                    fullWidth
                                                    type={field.type}
                                                    disabled={field.disabled}
                                                    name={field.name}
                                                    value={field.value}
                                                    placeholder={field.placeholder}
                                                    onClick={field.onClick}
                                                    readOnly={field.readOnly}
                                                    error={Boolean(field.error)}
                                                    helperText={field.helperText}
                                                    onChange={field.onChange}
                                                />
                                                {!field.disabled &&
                                                    <div
                                                        className="absolute top-[2rem] right-[10px]"
                                                        onClick={field.onClick}
                                                    >
                                                        <CalendarIcon />
                                                    </div>}
                                            </Box>
                                        </FormControl>
                                    ) : field.type === 'file' ? (
                                        <FormControl variant="standard" fullWidth >
                                            <FormLabel shrink required={field.required}>
                                                {field.label}
                                            </FormLabel>
                                            <div className="mt-4">
                                                <FileUploadComponent
                                                    field={field}
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    errors={errors}
                                                    setErrors={setErrors}
                                                />
                                            </div>
                                        </FormControl>)
                                        : <FormControl variant="standard" fullWidth>
                                            <FormLabel shrink required={field.required}>
                                                {field.label}
                                            </FormLabel>
                                            <FormField
                                                fullWidth
                                                type={field.type}
                                                name={field.name}
                                                value={field.value}
                                                disabled={field?.disabled}
                                                placeholder={field.placeholder}
                                                onChange={handleChange}
                                                error={Boolean(field.error)}
                                                helperText={field.helperText}
                                                multiline={field.multiline}
                                                rows={field.rows}
                                            />
                                        </FormControl>
                                    }
                                </Grid>
                            ))}
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} className="flex gap-2 justify-content-center">
                                {slotData?.type !== "Booked" && hasAuthority(["delete-apheresis-slot"], bmr_permissions) &&
                                    <LoadingButton
                                        loading={isLoading && actionType === "delete"}
                                        type="button"
                                        // fullWidth
                                        onClick={() => handleAction("delete")}
                                        className="!border-[#FF2023] !text-[#FF2023] w-40"
                                        variant="outlined"
                                        disabled={isLoading}
                                    >
                                        Delete
                                    </LoadingButton>}
                                {slotData?.type === "Request" && hasAuthority(["confirm-apheresis-slot"], bmr_permissions) && (
                                    <LoadingButton
                                        loading={isLoading && actionType === "confirm"}
                                        type="button"
                                        // fullWidth
                                        onClick={() => handleAction("confirm")}
                                        className="!bg-[#00B278] w-40"
                                        color="success"
                                        variant="contained"
                                        disabled={isLoading}
                                    >
                                        Confirm
                                    </LoadingButton>
                                )}
                                {slotData?.type !== "Booked" && hasAuthority(["update-apheresis-slot"], bmr_permissions) &&
                                    <LoadingButton
                                        loading={isLoading && actionType === "update"}
                                        type="button"
                                        className="w-40"
                                        onClick={() => handleAction("update")}
                                        // fullWidth
                                        variant="contained"
                                        disabled={isLoading}
                                    >
                                        Update
                                    </LoadingButton>}
                            </Grid>
                        </Grid>
                    </form>

                    <BsModal open={calendarOpen} size={"sm"} fullWidth={true} onClose={handleCloseCalendarModal}>
                        <CalendarModel
                            disabledAction
                            rageDate={slotData?.request_date}
                            handleSelectedSlot={handleSelectedSlot}
                            actionValues={formData}
                            handleCloseModal={handleCloseCalendarModal} />
                    </BsModal>
                    <DeleteModal
                        open={deleteOpen}
                        setClose={setDeleteOpen}
                        title={"Are you sure you want to Delete Slot?"}
                        buttonText={"Delete"}
                        handleSuccess={() => handleDeleteSlot()}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ApheresisUpdateForm;